import { useControlsContext } from '@/components/widgets/o/Map/hooks/useFormControls';

export const useLayerOpacity = () => {
  const controlsForm = useControlsContext();
  const opacityValue = controlsForm.watch('layerOpacity');

  return opacityValue / 100;
};
